import React, { useEffect } from 'react';
import { DebtInvestorsDisclaimerProps } from './config';
import Cookies from 'js-cookie';

const DebtInvestorsDisclaimer = ({ disclaimerpage }: DebtInvestorsDisclaimerProps) => {
  useEffect(() => {
    const cookieName = 'TU_DISCLAIMER',
      cookieValue = 'agreed',
      cookieVal = Cookies.get(cookieName);
    if (typeof cookieVal == 'undefined' || cookieVal !== cookieValue) {
      if (typeof disclaimerpage !== 'undefined' && disclaimerpage !== '') {
        const redirectCookieName = 'TU_DISCLAIMER_REDIRECT',
          redirectCookieValue = window.location.href;
        Cookies.set(redirectCookieName, redirectCookieValue, { expires: 1 });
        window.location.replace(disclaimerpage);
      }
    }
  }, []);
  return <div className="tu-debt-investors-disclaimer fn_disclaimer-container"></div>;
};

export default DebtInvestorsDisclaimer;
